import appConfig from "@/appConfig";
import { AdUnit } from "@/types/ads";
import { IUserProfile } from "@/types/user";


/**
 * Validates an email address format
 * @param email - The email address to validate
 * @returns boolean indicating if the email format is valid
 */
export const validateEmail = (email: string): boolean => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};


export const getAdsConfig = (adUnit: AdUnit, adNetwork: string, page: string, test = false) => {
    if (adUnit) {
        return {
            adClientId: adUnit.conf.clientID,
            adSlot: adUnit.conf.unitID,
            adFormat: 'display',
            adChannel: '',
            adTest: test ? 'on' : 'off',
            adStyle: 'display',
            adUnitId: adUnit.conf.unitID,
        };
    }
}

export const isVip = (profile: IUserProfile | null) => {
    if (!profile) {
        return false;
    }
    return profile.premiumType >= 1;
}

export const getPathName = (pathName: string, headersList: any) => {
    const host = headersList.get('host') || '';
    const pathArray = pathName.split('/');
    let lang = appConfig.locales.includes(pathArray[1]) ? pathArray[1] : appConfig.defaultLocale;

    const isIpAddress = /^(\d{1,3}\.){3}\d{1,3}$/.test(host.split(':')[0]);
    if (host && pathName) {
        if (host.includes('localhost') || process.env.NEXT_PUBLIC_DOMAIN?.includes(host) || process.env.NEXT_PUBLIC_DOMAIN_PREVIEW?.includes(host) || isIpAddress) {
            if (lang && appConfig.locales.includes(lang) && lang !== appConfig.defaultLocale) {
                pathName = pathArray[2];
            } else {
                pathName = pathArray[1];
            }
        } else {
            pathName = '';
        }
    } else {
        pathName = '';
    }
    if (pathName === '') {
        console.error('check host includes process.env:', pathName);
    }
    console.error('pathName:', pathName);
    return pathName;
}


export const getCookiePath = (pathName: string, lang: string) => {
    if (lang === 'en') {
        return `${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/${pathName}`;
    } else {
        return `${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/${lang}/${pathName}`;
    }
}